import { render, staticRenderFns } from "./diy-audiences-attribute.vue?vue&type=template&id=04e2f23f&scoped=true&"
import script from "./diy-audiences-attribute.vue?vue&type=script&lang=js&"
export * from "./diy-audiences-attribute.vue?vue&type=script&lang=js&"
import style0 from "./diy-audiences-attribute.vue?vue&type=style&index=0&id=04e2f23f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e2f23f",
  null
  
)

export default component.exports